import * as Yup from "yup";



export const updateNewLiftSchema = Yup.object({

    // liftQuotationNo:Yup.string().required("Please enter your Lift Quotation No."), 
    // newLiftNumber:Yup.string().required("Please enter your New Lift Number."),
    // customerName: Yup.string().min(2).max(25).required("Please enter your name"),
    // gstNo: Yup.string().required("Please enter your GST No."),
    // panNo: Yup.string().required("Please enter your PAN No."),
    // inputEmail: Yup.string().email().required("Please enter your email"),
    // mobileNo: Yup.number().integer().positive().required("Please enter your mobile number"),
    // quotationNo:Yup.string().required("Please enter your Lift Quotation No."), 
    // preAddres: Yup.string().required("Please enter Your Address "),
    // subject: Yup.string().required("Please enter your Subject "),
    // requireTo: Yup.string().required("Please enter Require To "),
    // liftType: Yup.string().required("Please enter lift type"),
    // capacity: Yup.string().required("Please enter Capacity"),
    // powerPackLocationNo:Yup.string().required("Please enter Your Power Pack Location No"),
    // motorMachine:Yup.string().required("Please enter Your Motor Machine"),
    // ropes:Yup.string().required("Please enter Your Ropes"),
    // speed:Yup.string().required("Please enter Your Speed"),
    // controller:Yup.string().required("Please enter Your controller"),
    // drive:Yup.string().required("Please enter Drive"),
    // signals:Yup.string().required("Please enter Signals"),
    // emergencySignals:Yup.string().required("Please enter Emergency Signals"),
    // liftTravel: Yup.string().required("Please enter lift travel "),
    // landingAndOpening:Yup.string().required("Please enter your landing And Opening"),
    // stops:Yup.string().required("Please enter your stops "),
    // carEncloser:Yup.string().required("Please enter your Car Encloser"),
    // flooring:Yup.string().required("Please enter your Flooring"),
    // doorType:Yup.string().required("Please Select Door type"),
    // landingDoor:Yup.string().required("Please enter your Landing Door"),
    // invoiceDate:Yup.string().required("Please enter date"),
    // quotationAmt: Yup.number().integer().positive().required("Please enter your Quotation Amount"),
    // previousBal: Yup.number().integer().positive().required("Please enter your Previous Balance"),
    // paidAmt:Yup.number().integer().positive().required("Please enter Paid Amount"),
    // totalBalance:Yup.number().integer().positive().required("Please enter Total Balance"),

  });